__turbopack_context__.v({
  "className": "ubHyiq_className",
  "variable": "ubHyiq_variable",
});
